import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Subject } from 'rxjs';
import { EMPTY, switchMap } from 'rxjs';
import { TranslocoService } from '@jsverse/transloco';
import { TitleService } from 'src/services/title.service';
import { MessageService } from 'primeng/api';
import { HttpErrorResponse } from '@angular/common/http';
import Helpers from 'src/shared/helpers';
import { TransactionQueryService } from '@/services/transaction-query.service';
import {
  TransactionQueryDetailsDTO,
  TransactionQueryResultDTO,
} from '@/interfaces/transactionQueryDetailsDTO.interface';

@Component({
  selector: 'app-transaction-query-details-page',
  standalone: false,
  templateUrl: './transaction-query-details-page.component.html',
})
export class TransactionQueryDetailsPageComponent implements OnInit, OnDestroy {
  private destroyed = new Subject<any>();
  private helpers: Helpers;

  messageKey: string = 'transactionQueryDetailsPage';
  queryDetails: TransactionQueryDetailsDTO | null = null;
  loading: boolean = true;

  constructor(
    private route: ActivatedRoute,
    private titleService: TitleService,
    private translocoService: TranslocoService,
    private messageService: MessageService,
    private transactionQueryService: TransactionQueryService,
  ) {
    this.helpers = Helpers.getInstance(this.translocoService);
  }

  ngOnInit(): void {
    this.titleService.setTitle('page_transaction_query_details');
    this.route.params
      .pipe(
        switchMap((params: Params) => {
          const id = params['id'];
          if (!id) return EMPTY;
          this.loading = true;
          return this.transactionQueryService.getQueryDetails(+id);
        }),
      )
      .subscribe({
        next: (details: TransactionQueryDetailsDTO) => {
          this.loading = false;
          this.queryDetails = details;
        },
        error: (response: HttpErrorResponse) => {
          this.loading = false;
          this.helpers.showApiResponseMessage(
            response,
            this.messageService,
            this.messageKey,
          );
        },
      });
  }

  getStatusClass(status: string): string {
    switch (status) {
      case 'Completed':
        return 'bg-green-lighter text-status-green';
      case 'Error':
        return 'bg-red-lighter text-status-red';
      case 'Pending':
        return 'bg-orange-light2 text-orange-default';
      default:
        return 'bg-grey-lighter text-grey-default';
    }
  }

  downloadReport(result: TransactionQueryResultDTO): void {
    this.transactionQueryService.downloadReport(result.id).subscribe({
      next: (blob: Blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = result.reportName || 'report';
        a.click();
        window.URL.revokeObjectURL(url);
      },
      error: (response: HttpErrorResponse) => {
        this.helpers.showApiResponseMessage(
          response,
          this.messageService,
          this.messageKey,
        );
      },
    });
  }

  ngOnDestroy(): void {
    this.destroyed.next(undefined);
    this.destroyed.complete();
  }
}
